import {useEffect, useState} from "react";
import { add2ActiveFormPanel, mrbgStore, setActivePopups } from "./mrbgRedux";
import MP_popUp from '../../static/css/MP_popUp.module.css'
import { mrbgTools } from '../../mrbgLib/mrbgTools.js'

function MrbgFullPopup(){

  const
    [activePopup,setActivePopUp] = useState( mrbgStore.getState().activePopups.fullPU );

  useEffect(()=>{
    if( activePopup==='cliFrame' ){
      mrbgStore.dispatch(add2ActiveFormPanel('cliFrame'))
      setTimeout(()=>{
        var myForm = document.getElementByDataID('cli');
        const timer = setTimeout( () => {
          window.scrollTo( 0,myForm?.getBoundingClientRect().top+window.scrollY-65 )
          clearTimeout(timer)
        },0 )
      },0)
    }
  },[activePopup])
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setActivePopUp( mrbgStore.getState().activePopups.fullPU );
    })
    return () =>unsubscribe();
  },[])

  return(
    <ul id={MP_popUp.fullPopupFrame}>
      <li id="soundAccess" className={activePopup=='soundAccess'? MP_popUp.active: ''}>
        <i className="fa-regular fa-circle-x" onClick={e=>mrbgStore.dispatch(setActivePopups({fullPU:null}))}></i>
        <h2>پخس نوتیفیکشن</h2>
        <div>
          در حال حاضر مرورگر شما اجازه پخش صدا را نمی دهد، برای دریافت نوتیفیکیشن باید اجازه پخش صدا را فعال کنید.
          <br/>
          <span id={MP_popUp.soundAccessBtn} onClick={e=>{new Audio('/notifSound/connection.wav').play()}}>اجازه می دهم</span>
        </div>
      </li>
    </ul>
  )
}
export default MrbgFullPopup;